<template>
  <div class="no-bg-button" :class="{ disabled }" @click="click">
    <div class="no-bg-button__icon" v-if="icon" v-html="icon"></div>
    <div class="no-bg-button__icon" v-else-if="withIcon">
      <slot name="icon"></slot>
    </div>

    <div class="no-bg-button__text">
      {{ label }}
    </div>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../utils/gogocodeTransfer'
export default {
  name: 'NoBgButton',
  props: {
    icon: {
      type: String,
      default: null,
    },
    label: {
      type: String,
    },
    withIcon: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    click() {
      if (this.disabled) {
        return
      }

      $emit(this, 'click')
    },
  },
  emits: ['click'],
}
</script>

<style lang="scss" scoped>
.no-bg-button {
  padding: 13px 26px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.2s linear;
  &:hover {
    opacity: 0.8;
  }

  &__icon {
    height: 14px;
    margin-right: 7px;

    display: flex;
    align-items: center;
    justify-content: center;

    :deep(svg) {
      max-width: 100%;
      max-height: 100%;
    }
  }

  &__text {
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #64748B;
  }

  &.disabled {
    cursor: not-allowed;
    filter: grayscale(100%);
  }
}
</style>
